export const XSMALL = "btn-xs";
export const SMALL = "btn-sm";
export const MEDIUM = "btn-md";
export const LARGE = "btn-lg";
